import { Link } from "react-router-dom";
import { MapPin, Mail, Globe, Phone } from "lucide-react";
import { CONTACT } from "@/data/content";

function Col({ title, children }) {
  return (
    <div>
      <h4 className="text-white font-outfit font-bold text-sm uppercase tracking-[0.14em] mb-5">
        {title}
      </h4>
      <ul className="space-y-3">{children}</ul>
    </div>
  );
}

function FLink({ to, children, testId }) {
  return (
    <li>
      <Link
        to={to}
        data-testid={testId}
        className="text-white/65 hover:text-white text-sm font-manrope transition-colors duration-200"
      >
        {children}
      </Link>
    </li>
  );
}

export default function Footer() {
  return (
    <footer className="relative bg-[#0A1F44] text-white overflow-hidden" data-testid="site-footer">
      <div className="absolute inset-0 flag-stripes opacity-40 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="inline-flex bg-white rounded-xl p-2.5 shadow-lg">
              <img src="/logo.png" alt="UK Student Job" className="h-12 w-auto rounded-md" />
            </div>
            <p className="mt-6 text-[#C8102E] font-outfit font-bold tracking-tight">
              Connecting Talent · Empowering Organisations
            </p>
            <p className="mt-4 text-white/65 text-sm leading-relaxed max-w-md font-manrope">
              UK Student Job is a specialist B2B partner for international candidate employment.
              Connecting job consultancies with an abundant, pre-verified international talent pool
              across Southampton and London.
            </p>
          </div>

          <div className="lg:col-span-2">
            <Col title="Services">
              <FLink to="/for-consultancies" testId="footer-consultancies">For consultancies</FLink>
              <FLink to="/compliance" testId="footer-compliance">Compliance</FLink>
              <FLink to="/contact" testId="footer-partner">Partner with us</FLink>
            </Col>
          </div>

          <div className="lg:col-span-3">
            <Col title="Universities">
              <FLink to="/about" testId="footer-uni-soton">University of Southampton</FLink>
              <FLink to="/about" testId="footer-uni-solent">Southampton Solent University</FLink>
              <FLink to="/about" testId="footer-eligibility">Candidate eligibility</FLink>
              <FLink to="/about" testId="footer-pipeline">Candidate pipeline</FLink>
            </Col>
          </div>

          <div className="lg:col-span-3">
            <Col title="Company">
              <FLink to="/about" testId="footer-about">About us</FLink>
              <FLink to="/contact" testId="footer-contact">Contact</FLink>
              <FLink to="/contact" testId="footer-privacy">Privacy policy</FLink>
              <FLink to="/contact" testId="footer-terms">Terms of service</FLink>
            </Col>
          </div>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-5 gap-6 border-t border-white/10 pt-10">
          <a href={CONTACT.phoneHref} className="flex items-start gap-3 group">
            <Phone className="h-5 w-5 text-[#C8102E] mt-0.5" />
            <span className="text-white/80 group-hover:text-white text-sm font-manrope">{CONTACT.phone}</span>
          </a>
          <a href={`mailto:${CONTACT.emailBusiness}`} className="flex items-start gap-3 group">
            <Mail className="h-5 w-5 text-[#C8102E] mt-0.5" />
            <span className="text-white/80 group-hover:text-white text-sm font-manrope break-all">{CONTACT.emailBusiness}</span>
          </a>
          <a href={`mailto:${CONTACT.emailInfo}`} className="flex items-start gap-3 group">
            <Mail className="h-5 w-5 text-[#C8102E] mt-0.5" />
            <span className="text-white/80 group-hover:text-white text-sm font-manrope break-all">{CONTACT.emailInfo}</span>
          </a>
          <a href={`https://${CONTACT.website}`} target="_blank" rel="noreferrer" className="flex items-start gap-3 group">
            <Globe className="h-5 w-5 text-[#C8102E] mt-0.5" />
            <span className="text-white/80 group-hover:text-white text-sm font-manrope">{CONTACT.website}</span>
          </a>
          <div className="flex items-start gap-3">
            <MapPin className="h-5 w-5 text-[#C8102E] mt-0.5" />
            <span className="text-white/80 text-sm font-manrope">{CONTACT.coverage}</span>
          </div>
        </div>

        <div className="mt-10 border-t border-white/10 pt-6">
          <p className="text-white/50 text-xs font-manrope">
            © 2026 UK Student Job. All rights reserved. Southampton · London · United Kingdom.
          </p>
        </div>
      </div>
    </footer>
  );
}
